import React from 'react';

import { ExternalLink } from '../../ui-components';
import { handleFormerInternalURLs } from '../../utils/link-handler';

/**
 * Rich-renderer function that can be consumed by React-Rich-Text render in order
 * to generate a styled element based on a particular rich text node, and it's
 * children
 *
 * @function
 * @param {object} node rich-text node
 * @param {element} children collection of child rich-text nodes
 */
const RichHyperlinkPreview = (node, children) => (
  <ExternalLink linkstyle="secondary-link" target="_blank" href={handleFormerInternalURLs(node.data.uri)}>
    {children}
  </ExternalLink>
);

export default RichHyperlinkPreview;
